"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.WITH_SUBMIT_BUTTON_TRAILING_WIDTH = exports.WITHOUT_SUBMIT_BUTTON_TRAILING_WIDTH = exports.WHCM_SEARCH_ICON_COLOR = exports.SEARCH_ICON_COLOR_DISABLED = exports.SEARCH_ICON_COLOR = exports.INSET_ELEMENT_TRAILING_INSET = void 0;

var _constants = require("../button/constants");

var defaultProps = {
  clearButtonAltText: 'Clear search',
  listActionButtonText: 'View all',
  loadingText: 'Searching...',
  noResultsText: 'No results found',
  resultCountText: function resultCountText(resultCount) {
    return "".concat(resultCount, " result").concat(resultCount === 1 ? '' : 's');
  },
  resultToString: function resultToString(result) {
    return String(result);
  },
  shouldAutocomplete: true,
  shouldOpenOnClick: false,
  shouldShowListOnNoResults: true,
  submitButtonAltText: 'Submit search',
  width: '100%'
};
exports.defaultProps = defaultProps;
var SEARCH_ICON_COLOR = 'neutral90';
exports.SEARCH_ICON_COLOR = SEARCH_ICON_COLOR;
var SEARCH_ICON_COLOR_DISABLED = 'neutral60';
exports.SEARCH_ICON_COLOR_DISABLED = SEARCH_ICON_COLOR_DISABLED;
var WHCM_SEARCH_ICON_COLOR = 'ButtonText';
exports.WHCM_SEARCH_ICON_COLOR = WHCM_SEARCH_ICON_COLOR;
var INSET_ELEMENT_TRAILING_INSET = 4;
exports.INSET_ELEMENT_TRAILING_INSET = INSET_ELEMENT_TRAILING_INSET;
var WITH_SUBMIT_BUTTON_TRAILING_WIDTH = 84; // Submit button is an icon-button and it's width would equal REGULAR_BUTTON_HEIGHT

exports.WITH_SUBMIT_BUTTON_TRAILING_WIDTH = WITH_SUBMIT_BUTTON_TRAILING_WIDTH;
var WITHOUT_SUBMIT_BUTTON_TRAILING_WIDTH = WITH_SUBMIT_BUTTON_TRAILING_WIDTH - _constants.REGULAR_BUTTON_HEIGHT - 12;
exports.WITHOUT_SUBMIT_BUTTON_TRAILING_WIDTH = WITHOUT_SUBMIT_BUTTON_TRAILING_WIDTH;